export default __webpack_public_path__ + "static/media/nuit_actif.042bd154.svg";